export type StaticPageErrorType = 'network' | 'not_found' | 'server' | 'unknown';

export interface StaticPageErrorDetails {
  type: StaticPageErrorType;
  title: string;
  message: string;
}

export function getStaticPageErrorDetails(err: unknown): StaticPageErrorDetails {
  const rawMessage = err instanceof Error ? err.message : String(err ?? '');
  const lower = rawMessage.toLowerCase();

  if (rawMessage === 'PAGE_NOT_FOUND' || lower.includes('not found')) {
    return {
      type: 'not_found',
      title: 'Page not found',
      message: 'The page you\'re looking for doesn\'t exist or may have been moved.',
    };
  }

  if (
    lower.includes('failed to fetch')
    || lower.includes('networkerror')
    || lower.includes('network request failed')
    || lower.includes('load failed')
    || lower.includes('network error')
  ) {
    return {
      type: 'network',
      title: 'Connection problem',
      message: 'We couldn\'t load this page. Check your internet connection and try again.',
    };
  }

  if (
    lower.includes('timeout')
    || lower.includes('503')
    || lower.includes('502')
    || lower.includes('500')
    || lower.includes('internal server error')
  ) {
    return {
      type: 'server',
      title: 'Something went wrong',
      message: 'Our servers are having trouble right now. Please try again in a moment.',
    };
  }

  return {
    type: 'unknown',
    title: 'Unable to load page',
    message: 'Something went wrong while loading this page. Please try again.',
  };
}
